module.exports = __webpack_public_path__ + "static/media/sample_lmloadshare.0557883e.csv";